export default __webpack_public_path__ + "static/media/01.48c2cca3.jpg";